import request from "./request";

const DashboardService = {
    GetLabHours: async (context, signal) => {
        return await request.sendRequest(`/dashboard/labhours`, context.token, signal);
    },
    SaveLabHours: async (payload, context, signal) => {
        return await request.sendPostRequest(`/dashboard/labhours`, payload, context, signal);
    },
    GetCourseChart: async (context, signal) => {
        return await request.sendRequest(`/course/dashboard/courses`, context.token, signal);
    },
    GetDocumentChart: async (context, signal) => {
        return await request.sendRequest(`/course/dashboard/documents`, context.token, signal);
    },
    GetUserDocumentChart: async (context) => {
        return await request.sendRequest(`/course/dashboard/user/documents`, context.token);
    },
    GetCatalogueChart: async (id, context,signal) => {
        return await request.sendRequest(`/incident/dashboard/course/${id ?? 0}`, context.token, signal);
    },
    GetAssessmentChart: async (context, signal) => {
        return await request.sendRequest(`/assessment/dashboard`, context.token, signal);
    },
    GetQuizChart: async (context, signal) => {
        return await request.sendRequest(`/quiz/dashboard/data`, context.token, signal);
    },
    GetTicketChart: async (context, signal) => {
        return await request.sendRequest(`/ticket/dashboard`, context.token, signal);
    },
    GetCalenderChart: async (context, startDate, endDate, signal) => {
        return await request.sendRequest(`/dashboard/${startDate}/${endDate}`, context.token, signal);
    },
    GetCourseCalenderChart: async (context, startDate, endDate) => {
        return await request.sendRequest(`/dashboard/course/${startDate}/${endDate}`, context.token);
    },
    GetLearnerCalenderChart: async (context, startDate, endDate ) => {
        return await request.sendRequest(`/dashboard/course/learners/${startDate}/${endDate}`, context.token);
    },
    GetLearnerCatalogueChart: async (id, context, signal) => {
        return await request.sendRequest(`/incident/dashboard/users/${id ?? 0}`, context.token, signal);
    },
};

export default DashboardService;
